import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from '../config/fbConfig';
import { collection, addDoc, doc, getDocs, updateDoc, deleteDoc, Timestamp } from 'firebase/firestore';
import Modal from 'react-modal';
import Logo from '../images/school_logo.png';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

Modal.setAppElement('#root');

const Terms = () => {
  const { user, userData } = useUserAuth();
  const [loading, setLoading] = useState(false);
  const [isLoadingTerms, setIsLoadingTerms] = useState(true); // 🔹 NEW
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [update, setUpdate] = useState(false);
  const [terms, setTerms] = useState([]);
  const [newTerm, setNewTerm] = useState({ name: '' });
  const [editingTerm, setEditingTerm] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentTerm, setCurrentTerm] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [filteredTerms, setFilteredTerms] = useState([]);


  // 🔹 NEW - Delete Confirmation
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [termToDelete, setTermToDelete] = useState(null);

  const termsCollectionRef = collection(db, "terms");

  useEffect(() => {
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    setIsLoadingTerms(true);
    try {
      const data = await getDocs(termsCollectionRef);
      const allTerms = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setTerms(allTerms);
      setFilteredTerms(allTerms); // Set filteredTerms initially
    } catch (error) {
      setError("Failed to fetch terms");
      setShowModal(true);
    } finally {
      setIsLoadingTerms(false);
    }
  };

  useEffect(() => {
    const filtered = terms.filter(term =>
      term.name.toLowerCase().includes(filterText.toLowerCase())
    );
    setFilteredTerms(filtered);
  }, [filterText, terms]);  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTerm({ ...newTerm, [name]: value });
  };

  const handleAddTerm = async () => {
    if (!newTerm.name.trim()) {
      setError("Term name cannot be empty");
      setShowModal(true);
      return;
    }
    setUpdate(true);
    try {
      await addDoc(termsCollectionRef, {
        ...newTerm,
        createdAt: Timestamp.now()
      });
      setSuccessMessage("Term added successfully");
      fetchTerms();
      setNewTerm({ name: '' });
      setIsAddModalOpen(false);
    } catch (error) {
      setError("Failed to add term");
    } finally {
      setUpdate(false);
      setShowModal(true);
    }
  };

  const handleUpdateTerm = async () => {
    setUpdate(true);
    try {
      const termDoc = doc(db, "terms", editingTerm.id);
      await updateDoc(termDoc, {
        name: newTerm.name
      });
      setSuccessMessage("Term updated successfully");
      fetchTerms();
      setEditingTerm(null);
      setNewTerm({ name: '' });
      setIsEditModalOpen(false);
    } catch (error) {
      setError("Failed to update term");
    } finally {
      setUpdate(false);
      setShowModal(true);
    }
  };

  const handleEditTerm = (termToEdit) => {
    setEditingTerm(termToEdit);
    setNewTerm({ name: termToEdit.name });
    setIsEditModalOpen(true);
  };

  const confirmDelete = (term) => {
    setCurrentTerm(term);
    // setTermToDelete(term);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteTerm = async (id) => {
    setUpdate(true);
    try {
      const termDoc = doc(db, "terms", id);
      await deleteDoc(termDoc);
      setSuccessMessage("Term deleted successfully");
      fetchTerms();
    } catch (error) {
      setError("Failed to delete term");
    } finally {
      setUpdate(false);
      setIsDeleteModalOpen(false);
      // setTermToDelete(null);
      setShowModal(true);
    }
  };

  if (loading) return <Loader text={"LOADING"} />;
  if (!userData) return <Loader text={"READING"} />;

  const allowedRoles = ['Admin', 'Cashier'];

  return (
    <>
      {update && <Loader text={"PROCESSING"} />}
      {allowedRoles.includes(userData.status) ? (
        <>
          <div className="top-elements row align-center space-between">
            <Link to="/home" className="back-link">
              <i className="fa-solid fa-arrow-left size3"></i>
            </Link>
            <div className="column align-center justify-center">
              <img src={Logo} className="middle-logo" alt="logo" />
            </div>
            <Link to="#" className="home-link" onClick={() => fetchTerms()}>
              <i className="fa-solid fa-rotate-right size4"></i>
            </Link>
          </div>

          <div className="login-page-items column align-center scroll-fixed">
            <h2 className="manage-page-heading caps size4">Manage Terms</h2>
            <button className="login-button login-button-d caps" onClick={() => setIsAddModalOpen(true)}>Add Term</button>
            <input
              type="text"
              placeholder="Search by name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              className="input-field1"
            />


            <div className="scroll-fixed scroll-fixed1">
              {isLoadingTerms ? (
                <p className="loading-text">Loading terms...</p>
              ) : terms.length === 0 ? (
                <p className="loading-text">No terms available.</p>
              ) : (
                <div className="class-list class-list-d scrollable">
                  {filteredTerms.map((termItem) => (
                    <div key={termItem.id} className="class-item">
                      <div className="row gap-2 align-center">
                        <p>{termItem.name}</p>
                      </div>
                      <div className="row align-center justify-center gap-15">
                        <button className="list-btn" onClick={() => handleEditTerm(termItem)}><i className="fas fa-edit"></i></button>
                        {/* <button className="list-btn" onClick={() => confirmDelete(termItem)}><i className="fas fa-trash-alt"></i></button>                     */}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>
      )}

      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => {
            setShowModal(false);
            setError("");
            setSuccessMessage("");
          }}
        />
      )}

      {/* Add Term Modal */}
      <Modal
        isOpen={isAddModalOpen}
        onRequestClose={() => setIsAddModalOpen(false)}
        contentLabel="Add Term"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Add Term</h2>
        <form className="session-form">
          <input
            type="text"
            name="name"
            className="input-field"
            placeholder="Term Name"
            value={newTerm.name}
            onChange={handleInputChange}
          />
          <div className="row align-center gap-1">
            <button className="login-button" type="button" onClick={() => setIsAddModalOpen(false)}>Cancel</button>
            <button className="login-button" type="button" onClick={handleAddTerm}>Add Term</button>
          </div>
        </form>
      </Modal>

      {/* Edit Term Modal */}
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={() => {
          setIsEditModalOpen(false);
          setNewTerm({ name: '' }); // Reset newTerm
          setEditingTerm(null); // Reset editingTerm
        }}
        contentLabel="Edit Term"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Edit Term</h2>
        <form className="session-form">
          <input
            type="text"
            name="name"
            className="input-field"
            placeholder="Term Name"
            value={newTerm.name}
            onChange={handleInputChange}
          />
          <div className="row align-center justify-center gap-1">
            <button className="login-button" type="button" onClick={() => {
                setIsEditModalOpen(false);
                setNewTerm({ name: '' }); // Reset newTerm
                setEditingTerm(null); // Reset editingTerm
              }}>Cancel</button>
            <button className="login-button" type="button" onClick={handleUpdateTerm}>Update Term</button>
          </div>
        </form>
      </Modal>

      {/* 🔹 Confirm Delete Modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => setIsDeleteModalOpen(false)}
        contentLabel="Confirm Delete"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Confirm Delete</h2>
        {currentTerm && (
          <div>
            <p>Are you sure you want to delete <strong>{currentTerm.name}</strong> term?</p>
            <div className="row align-center justify-center gap-1">
              <button className="login-button" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
              <button className="login-button" onClick={() => handleDeleteTerm(currentTerm.id)}>Delete</button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Terms;
